import { assert } from '@/utils/assert'
import { Address, zeroAddress } from 'viem'

import { NATIVE_ASSET_MOCK_ADDRESS, SWAP_VAULT_CONTRACT } from '@/config/consts'
import { wethGatewayAddress } from '@/config/contracts-generated'
import { getChainConfigEntry } from '@/config/chain'
import { contractBook } from '@eulerxyz/core-sdk'

/**
 * Do basic sanity checks when sending txs.
 * These checks should never fail in real life scenario but it's the final line of defense against bugs in the app.
 */
export function sanityCheckTx(tx: { address?: Address; value?: bigint }, chainId: number): void {
  assert(tx.address, 'Address is required')
  assert(tx.address.toLowerCase() !== NATIVE_ASSET_MOCK_ADDRESS.toLowerCase(), 'Cannot interact with ETH mock address')
  assert(tx.address !== zeroAddress, 'Cannot interact with zero address')
  const wrappedNativeAssetAddress = getChainConfigEntry(chainId).markets?.nativeAssetInfo.wrappedNativeAssetAddress

  if (tx.value && tx.address !== SWAP_VAULT_CONTRACT) {
    const evcAddress =
      contractBook.evc.address[chainId as keyof typeof contractBook.evc.address]
    assert(
      tx.address === (wethGatewayAddress as any)[chainId] ||
        tx.address === wrappedNativeAssetAddress ||
        (evcAddress && tx.address.toLowerCase() === evcAddress.toLowerCase()),
      'Sending the native asset is only allowed to gateway contracts',
    )
  }
}
